export const METALICO_ID = 1;
export const GIRO_ID = 2;
export const TRANSFERENCIA_ID = 3;
export const METALICO_CON_TARJETA_ID = 4;

export default class FormaPago {
  constructor(data) {
    Object.assign(this, data);
  }

  get esMetalico() {
    return this.id === METALICO_ID || this.id === METALICO_CON_TARJETA_ID;
  }

  get esTransferencia() {
    return this.id === TRANSFERENCIA_ID;
  }

  get esGiro() {
    return this.id === GIRO_ID;
  }
}
